import { SocialContentLanguageMode } from "src/api/client-api/social/useSocialContentLanguagePreference";
import type { TranslatableContent } from "../components/SocialContentLanguageToggle";

type SocialContentFields = TranslatableContent & {
    content?: string;
};

export const resolveSocialDisplayContent = (item: SocialContentFields, mode: SocialContentLanguageMode): string => {
    const original = item.originalContent ?? item.content ?? "";

    if (mode === "original") {
        return original;
    }

    if (item.translationStatus === "translated") {
        return item.content ?? original;
    }

    return original;
};
